var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{
  'wgt-ab-test': true
}},[_c('div',{staticClass:"wgt-bd"},[(_vm.showEdit)?_c('div',{staticClass:"placeholder"},[_vm._v("点击编辑“AB实验”")]):_c('div',_vm._l((_vm.value.experiment.list[_vm.value.experiment.groupIndex].children),function(wgt,index){return _c(wgt.name,{key:`ab-component__${index}`,tag:"component",attrs:{"value":wgt}})}),1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }